import React, { useState, useCallback } from "react";
import { Box, Button, TextField, Typography, Modal } from "@mui/material";
import { deleteWeight } from "../../services/ConnectDataBase";
import { typeConnect } from "../../constants/Constants";
import { BACKGROUND_COLORS, BRAND_COLORS } from "../../style/colors.js";

export default function DeleteWeightButton({
  currentScreenId,
  onWeightDeleted,
  isResetModalOpen,
  toggleResetModal,
}) {
  const [moReset, setMoReset] = useState("");

  const resetWeightClasification = useCallback(async () => {
    try {
      const moResetStatus = await deleteWeight(
        typeConnect[2],
        currentScreenId,
        moReset
      );
      if (!moResetStatus) return;

      setMoReset("");
      // Cerrar primero: si onWeightDeleted falla/tarda, el modal no debe quedarse abierto
      toggleResetModal();
      if (typeof onWeightDeleted === "function") {
        await onWeightDeleted();
      }
    } catch (error) {
      console.error(error);
    }
  }, [moReset, currentScreenId, onWeightDeleted, toggleResetModal]);

  return (
    <Modal open={isResetModalOpen} onClose={toggleResetModal}>
      <Box
        sx={{
          backgroundColor: BACKGROUND_COLORS.CARD,
          padding: 3,
          margin: "auto",
          marginTop: "10%",
          maxWidth: 400,
          borderRadius: 1,
          boxShadow: 24,
        }}>
        <Typography variant='h6' sx={{ mb: 2 }}>
          Borrar Peso de Clasificación
        </Typography>
        <TextField
          fullWidth
          label='MO'
          variant='outlined'
          value={moReset}
          onChange={(e) => setMoReset(e.target.value)}
          placeholder='Introduce la MO para resetear'
          sx={{ mb: 2 }}
        />
        <Button
          variant='contained'
          color='primary'
          fullWidth
          onClick={resetWeightClasification}
          sx={{
            backgroundColor: BRAND_COLORS.PRIMARY,
            "&:hover": { backgroundColor: BRAND_COLORS.PRIMARY_DARK },
          }}>
          Borrar Peso
        </Button>
      </Box>
    </Modal>
  );
}
